import React, { useState, useContext, useRef } from "react";
import { useIntl } from "gatsby-plugin-intl";
import { CSSTransition } from "react-transition-group";
import Slider from "react-slick";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import { GlobalDispatchContext, GlobalStateContext } from "../context";
import QrCode from "./buyPopup/qrCode";

import CloseIcon from "./closeIcon";
import KCReactPlayer from "./kcReactPlayer";
import { parseSKUFromProductImage } from "../../utils";

const StyledWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: ${(props) => (props.isShown ? "flex" : "none")};
  opacity: 1;
  overflow: scroll;
  flex-direction: column;
  align-items: stretch;
  background-color: ${(props) => props.theme.color.smoke};

  &.fade-enter {
    opacity: 0;
    display: flex;
  }

  &.fade-enter-active {
    opacity: 1;
    transition: 1s opacity;
  }

  &.fade-enter-done {
    opacity: 1;
    display: flex;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: 0.3s opacity;
  }

  &.fade-exit-done {
    opacity: 0;
    display: none;
  }

  ${(props) => props.theme.responsive.desktop} {
    overflow: hidden;
    flex-direction: row;
  }
`;

const StyledPreview = styled.div`
  flex: 1;
  position: relative;
  width: 100%;
  ${(props) => props.theme.responsive.desktop} {
    width: 50%;
  }
`;

const StyledCarousel = styled(Slider)`
  font-size: 0;
  position: relative;
  height: 100%;
  * {
    outline: none !important;
  }
  &:hover {
    cursor: pointer;
  }
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;

const StyledCaptionWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  font-family: ${(props) => props.theme.font.sans};
  width: 50%;
`;

const StyledCaption = styled.div`
  font-size: 1.4rem;
`;

const CarouselNavigationWrapper = styled.div`
  display: flex;
  margin-top: 4px;
`;

const StyledNavigationButton = styled.div`
  border-radius: 50%;
  width: 0.4rem;
  height: 0.4rem;
  background-color: ${(props) =>
    props.isSelected ? props.theme.color.dimGrey : "transparent"};
  border: 1px solid ${(props) => props.theme.color.dimGrey};
  margin-right: 0.4rem;
`;

const StyledRender = styled.div`
  width: 100%;
  margin: 0;
  height: 100%;
  background-color: ${(props) => props.theme.color.smoke};
  ${(props) => props.theme.responsive.desktop} {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Render = ({ img, ...props }) => {
  return (
    <StyledRender
      imgStyle={{
        margin: 0,
        objectFit: "cover",
        objectPosition: "center center",
      }}
      fluid={img}
    >
      <GatsbyImage image={getImage(img)} />
    </StyledRender>
  );
};

const StyledSidebar = styled.div`
  z-index: 20;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  background-color: ${(props) => props.theme.color.white};
  font-family: ${(props) => props.theme.font.sans};
  padding: 1rem;
  ${(props) => props.theme.responsive.desktop} {
    flex-direction: column;
    width: 20rem;
    ${(props) => props.theme.shadow}
  }
`;

const StyledVideoWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: 2px;
`;

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 1.2rem;
  margin-top: 1.2rem;
`;

const StyledBody = styled.div`
  margin-top: 0.6rem;
  font-size: 0.9rem;
  line-height: 1.2rem;
`;

const StyledCTAWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const StyledCTA = styled.div`
  flex: 1;
  margin-top: 1rem;
  background-color: ${(props) => props.theme.color.darkGrey};
  padding: 1rem;
  text-align: center;
  border-radius: 2px;
  color: white;
  font-weight: bold;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.color.black};
  }
`;

var scrollSettings = {
  slidesPerRow: 1,
  arrows: false,
  accessibility: false,
  rows: 1,
  dots: false,
  pauseOnFocus: true,
};

const InstallPopup = ({ ...props }) => {
  const state = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const isShown = state.isInstallPopupShown;
  const scrollWrapperRef = useRef(null);
  const sku = "pd10performancedistressed";

  const intl = useIntl();
  return <></>;

  //   const { scanPlaceholder, allFile } = useStaticQuery(graphql`
  //     {
  //       scanPlaceholder: file(
  //         relativePath: { eq: "Placeholder/scan-placeholder.png" }
  //       ) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 900
  //             formats: [AUTO, WEBP, AVIF]
  //             layout: CONSTRAINED
  //           )
  //         }
  //       }
  //       allFile(
  //         filter: {
  //           relativePath: {
  //             regex: "/Product/(?:pd10|pd10performancedistressed).*.png/"
  //           }
  //         }
  //       ) {
  //         edges {
  //           node {
  //             name
  //             publicURL
  //             relativeDirectory
  //             childImageSharp {
  //               gatsbyImageData(
  //                 quality: 100
  //                 formats: [AUTO, WEBP, AVIF]
  //                 layout: FULL_WIDTH
  //                 placeholder: BLURRED
  //               )
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `);

  //   let frameShots = {};
  //   allFile.edges.forEach((e) => {
  //     let node = e.node;
  //     let dir = node.relativeDirectory;
  //     let img = node.childImageSharp.gatsbyImageData;
  //     let name = node.name;
  //     let [sku, frame, lens] = parseSKUFromProductImage(dir);
  //     let key = `${sku}-${frame}-${lens}`;
  //     if (key in frameShots) {
  //       frameShots[key][name] = img;
  //     } else {
  //       frameShots[key] = { [name]: img };
  //     }
  //   });

  //   const getImageKey = (sku, spec) => {
  //     const color = spec.selectedFrameColor.name.en.replace(" ", "-");
  //     const lens = spec.selectedLens.name.en.replace(" ", "-");
  //     return `${sku}-${color}-${lens}`;
  //   };

  //   //   let specImages = frameShots[getImageKey(sku, curFrame)];
  //   //   let carouselImages = [
  //   //     specImages.front,
  //   //     specImages.model1,
  //   //     specImages.model2,
  //   //     specImages.action,
  //   //     specImages.material,
  //   //     specImages.hinge,
  //   //     specImages.temple,
  //   //     specImages.lens,
  //   //   ];

  //   //   const handlerClosePopup = () => {
  //   //     dispatch({
  //   //       type: "SET_INSTALL_POPUP_SHOWN",
  //   //       isShown: false,
  //   //     });
  //   //   };

  //   //   const handleInstallApp = () => {
  //   //     window.location.href =
  //   //       "https://apps.apple.com/us/app/king-children/id1351987953";
  //   //   };

  //   //   const [carouselIndex, setCarouselIndex] = useState(0);

  //   return (
  //     <CSSTransition in={isShown} timeout={1000} classNames="fade">
  //       <StyledWrapper className="fade" isShown={isShown}>
  //         {/* <StyledPreview>
  //           <StyledCarousel
  //             ref={scrollWrapperRef}
  //             {...scrollSettings}
  //             beforeChange={(oldI, newI) => {
  //               setCarouselIndex(newI);
  //             }}
  //           >
  //             {carouselImages.map((img, i) => {
  //               return (
  //                 <div
  //                   onClick={() => {
  //                     if (scrollWrapperRef.current) {
  //                       scrollWrapperRef.current.slickNext();
  //                     }
  //                   }}
  //                   key={i}
  //                 >
  //                   <Render img={img} />
  //                 </div>
  //               );
  //             })}
  //           </StyledCarousel>
  //           <CloseButtonWrapper>
  //             <CloseIcon handlerClick={() => handlerClosePopup()} size={1} />
  //           </CloseButtonWrapper>
  //           <StyledCaptionWrapper>
  //             <StyledCaption>
  //               <b>PD10</b> Collection
  //             </StyledCaption>
  //             <CarouselNavigationWrapper>
  //               {carouselImages.map((img, i) => (
  //                 <StyledNavigationButton
  //                   onClick={() => {
  //                     setCarouselIndex(i);
  //                     if (scrollWrapperRef.current) {
  //                       scrollWrapperRef.current.slickGoTo(i, false);
  //                     }
  //                   }}
  //                   isSelected={carouselIndex === i}
  //                   key={i}
  //                 />
  //               ))}
  //             </CarouselNavigationWrapper>
  //           </StyledCaptionWrapper>
  //         </StyledPreview>
  //         <StyledSidebar>
  //           <StyledVideoWrapper>
  //             <KCReactPlayer
  //               img={scanPlaceholder}
  //               url="https://vimeo.com/434499914"
  //             />
  //           </StyledVideoWrapper>
  //           <div>
  //             <StyledTitle>
  //               {intl.formatMessage({ id: `installPopup.title` })}
  //             </StyledTitle>
  //             <StyledBody>
  //               {intl.formatMessage({ id: `installPopup.body` })}
  //             </StyledBody>
  //             <StyledCTAWrapper>
  //               <StyledCTA onClick={() => handleInstallApp()}>
  //                 {intl.formatMessage({ id: `installPopup.cta` })}
  //               </StyledCTA>
  //               <QrCode />
  //             </StyledCTAWrapper>
  //           </div>
  //         </StyledSidebar> */}
  //       </StyledWrapper>
  //     </CSSTransition>
  //   );
};

export default InstallPopup;
